import React, { useEffect, useState } from "react";

import { createForm } from "@formily/core";
import { createSchemaField } from "@formily/react";
import {
  Form,
  FormItem,
  Input,
  Password,
  Submit,
  Select,
  FormButtonGroup,
} from "@formily/antd";
import { Card } from "antd";
import "antd/lib/button/style";
import { request, requestkind } from "../../unit/request";
import { Modal } from "antd";
import { FormProvider, Field, VoidField } from "@formily/react";
import conf from "../../conf/config";
const form = createForm({
  validateFirst: true,
});

const Profile = () => {
  const get = async () => {
    try {
      const json = await request(
        {},
        {},
        requestkind.Authentication.GetUserInfo
      );
      console.log(json);
      const { Data } = json;
      form.setInitialValues(Data);
    } catch (error) {
      console.log("err in profile", error);
      // Modal.error({
      //     title: '错误！',
      //     content: error.toString()
      // });
    }
  };

  useEffect(() => {
    get();
  }, []);
  const [loading, setLoading] = useState<boolean>(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        background: "#eee",
        padding: "40px 0",
      }}
    >
      <Card
        bordered={false}
        title="更改资料"
        style={{ width: 620 }}
      >
        <FormProvider form={form}>
          <Field
            name="UserId"
            title="userId"
            display="hidden"
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="UserName"
            title="账号"
            // display="hidden"
            disabled={true}
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="UserDisplayName"
            title="姓名"
            required
            validator={{ maximum: 20 }}
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="Mobile"
            title="电话"
            validator={{ maximum: 20 }}
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="Email"
            title="电子邮件"
            required
            // validator={{ maximum: 20 }}
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <Field
            name="PartnerNumber"
            title="合作伙伴ID"
            hidden={true}
            decorator={[FormItem]}
            component={[
              Input,
              {
                style: {
                  width: 300,
                },
              },
            ]}
          />
          <FormButtonGroup.FormItem>
            <Submit
              disabled={loading}
              onSubmit={async (values) => {
                console.log(values);
                setLoading(true);
                const session: any = sessionStorage.getItem(
                  `oidc.user:${conf.oidcConfig.authority}:CreditCheckExternal-UI`
                );
                const { access_token } = JSON.parse(session);
                values["token"] = access_token;
                const { IsSuccess, Msg } = await request(
                  values,
                  {},
                  requestkind.Authentication.UpdateUserInfo
                );
                setLoading(false);
                if (IsSuccess) {
                  Modal.success({
                    title: "成功",
                    content: Msg,
                  });
                } else {
                  Modal.error({
                    title: "错误",
                    content: Msg,
                  });
                  setLoading(false);
                }
              }}
            >
              {loading ? "正在提交" : "提交"}
            </Submit>
          </FormButtonGroup.FormItem>
        </FormProvider>
      </Card>
    </div>
  );
};
export default Profile;
